module.exports = __webpack_public_path__ + "img/Hernan-Ferraro.e5b41d69.jpg";